// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"58e5da86","125":"8aa5474f","143":"fb8457df","486":"ddb3868b"}[chunkId] + ".chunk.js";
};